import { $NoApplicationsContainer } from 'benefit/applicant/components/applications/Applications.sc';
import { ROUTES } from 'benefit/applicant/constants';
import { ButtonPresetTheme, IconDocument, IconPlus, IconSize } from 'hds-react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';
import Button from 'shared/components/button/Button';

const NoApplications = (): JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <$NoApplicationsContainer>
      <IconDocument size={IconSize.ExtraLarge} />
      <h2>{t('common:applications.list.noApplications')}</h2>
      <Button
        onClick={() => router.push(ROUTES.APPLICATION_FORM)}
        iconStart={<IconPlus />}
        theme={ButtonPresetTheme.Coat}
      >
        {t('common:mainIngress.frontPage.newApplicationBtnText')}
      </Button>
    </$NoApplicationsContainer>
  );
};

export default NoApplications;
